import React, { useState, useEffect, useMemo } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import 'moment/locale/ko';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { debounce } from 'lodash';
import { SingleDatePicker } from 'react-dates';

moment.locale('ko');

const DatePickerWrapper = styled.div`
  .SingleDatePicker {
    width: 100%;
  }

  .SingleDatePickerInput {
    width: 100%;
    border: 1px solid #ddd;
    border-radius: 4px;
    background-color: white;
  }

  .DateInput {
    width: 100%;
  }

  .DateInput_input {
    font-size: 14px;
    color: #333;
    padding: 8px 12px;
    width: 100%;
  }
`;

export const DatePicker = ({
  value,
  onChange,
  style,
}: {
  value?: string;
  onChange?: (date: string | null) => void;
  style?: React.CSSProperties;
}) => {
  const [date, setDate] = useState<moment.Moment | null>(null);
  const [focused, setFocused] = useState<boolean>(false);


  // debounce된 상태 업데이트 함수
  const debouncedSetDates = useMemo(
    () =>
      debounce((newValue) => {
        if (newValue) {
          setDate(moment(newValue));
        } else {
          setDate(null);
        }
      }, 300),
    []
  );

  useEffect(() => {
    debouncedSetDates(value);
    return () => {
      debouncedSetDates.cancel();
    };
  }, [value]);

  const handleDateChange = (date: moment.Moment | null) => {
    setDate(date);
    if (date) {
      onChange?.(date.format('YYYY-MM-DD'));
    } else {
      onChange?.(null);
    }
  };

  useEffect(() => {
    if (value) {
      setDate(moment(value));
    }
  }, [value]);

  return (
    <DatePickerWrapper style={style}>
      <SingleDatePicker
        date={date}
        onDateChange={handleDateChange}
        focused={focused}
        onFocusChange={({ focused }) => setFocused(focused)}
        id="single_date_picker"
        numberOfMonths={1}
        hideKeyboardShortcutsPanel
        isOutsideRange={(day) => day.isBefore(moment(), 'day')}
        placeholder="날짜 선택"
        displayFormat="YYYY-MM-DD"
        readOnly={false}
        showClearDate={true}
        noBorder
        anchorDirection="left"
        openDirection="down"
        horizontalMargin={0}
        verticalSpacing={0}
      />
    </DatePickerWrapper>
  );
};
